<template>
  <v-card style="overflow-y: hidden;">
    <v-container>
      <v-row>
        <v-col cols="10" offset="1">
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col align="center">
                  <PageTitle :title="label('title')"/>
                </v-col>
              </v-row>
              <v-row v-if="withTerm">
                <TermForm
                        v-model="agree"
                />
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <ul class="notes">
                    <li>
                      応募した企業には、全ての情報が公開されます
                    </li>
                    <li>
                      <v-icon small class="pb-1">mdi-lock</v-icon>マークのついている項目は、スカウトサービスで企業には公開されません
                    </li>
                    <li>
                      Nishika Connectで登録いただいた情報は、Nishika（コンペティション）ユーザーには公開されません。Nishikaで登録した情報だけ公開されます
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <v-row>
                <ProfileDetailForm
                        :user="data.user"
                        :userCandidate="data.userCandidate"
                        :userLanguages="data.userLanguages"
                        :isSignUp="isSignUp"
                        @updateUser="onUpdateUser"
                        @updateUserCandidate="onUpdateUserCandidate"
                        show-user-name
                />
              </v-row>
              <v-row>
                <EducationForm
                        v-model="data.user"
                />
              </v-row>
              <v-row>
                <CareerHistory
                        v-model="data.userCareers"
                        :currentJob="data.userCandidate.currentJob"
                        :no-career="noCareer"
                        @inputNoCareer="onInputNoCareer"
                        @inputCurrentJob="onInputCurrentJob"
                />
              </v-row>
              <v-row>
                <ProfileAdditionalForm
                        v-model="data.user"
                />
              </v-row>
              <v-row>
                <v-col cols="12">
                  <SectionTitle :title="label('others')"/>
                </v-col>
              </v-row>
              <v-row>
                <FormItem :name="label('introduction')">
                  <TextArea
                      v-model="data.userCandidate.introduction"
                      :name="label('introduction')"
                      :max="2000"
                      :submit="submit"
                      :hint="label('introductionHint')"
                  />
                </FormItem>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <SectionTitle :title="label('companiesNotAllowSearch')"/>
                </v-col>
              </v-row>
              <v-row id="building">
                <FormItem :name="label('companyName')" secret>
                  <TextField
                      v-model="data.company1"
                      :name="label('companyName')"
                      :max="255"
                  />
                  <TextField
                      v-model="data.company2"
                      :name="label('companyName')"
                      :max="255"
                  />
                  <TextField
                      v-model="data.company3"
                      :name="label('companyName')"
                      :max="255"
                  />
                </FormItem>
              </v-row>
              <v-row v-if="completedMessage">
                <MessageBox type="success" :message="completedMessage"/>
              </v-row>
              <v-row v-if="errorMessage">
                <ErrorMessage :message="errorMessage"/>
              </v-row>
              <v-row>
                <v-col cols="6" :offset="saveButtonOffset">
                  <ActionButton type="save" @click="submit" :disabled="withTerm && !agree">
                    {{label("save")}}
                  </ActionButton>
                </v-col>
                <v-col cols="6" v-if="!hideCancel">
                  <ActionButton type="cancel" @click="onClose">
                    {{label("cancel")}}
                  </ActionButton>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import PageTitle from "../../atoms/PageTitle";
  import ProfileDetailForm from "../../organisms/ProfileDetailForm";
  import EducationForm from "../../organisms/EducationForm";
  import CareerHistory from "../../organisms/CareerHistory";
  import ProfileAdditionalForm from "../../organisms/ProfileAdditionalForm";
  import ActionButton from "../../molecules/ActionButton";
  import ErrorMessage from "../../molecules/ErrorMessage";
  import ComponentMixin from "../../ComponentMixin";
  import _clone from "lodash/clone"
  import {mapGetters} from "vuex";
  import MessageBox from "../../atoms/MessageBox";
  import ApiMixin from "../../../ApiMixin";
  import TermForm from "../../organisms/TermForm";
  import SectionTitle from "../../atoms/SectionTitle";
  import FormItem from "../../molecules/FormItem";
  import TextArea from "../../atoms/TextArea";
  import TextField from "@/components/atoms/TextField";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "ProfileEditPage",
    isRequiredLogin: true,
    data () {
      return {
        data: {
          user: {},
          userCandidate: {},
          userLanguages: [],
          userCareers: [],
          company1: null,
          company2: null,
          company3: null,
        },
        agree: false,
        completedMessage: null,
        errorMessage: null,
        noCareer: false,
      };
    },
    props: {
      close: {
        type: Function
      },
      hideCancel: {
        type: Boolean
      },
      open: {
        type: Boolean
      },
      withTerm: {
        type: Boolean,
        default: false
      }
    },
    beforeMount () {
      this.init();
    },
    methods: {
      init () {
        this.data.user = _clone(this.user);
        this.data.userCandidate = _clone(this.userCandidate);
        this.data.userLanguages = _clone(this.userLanguages)
        this.data.userCareers = _clone(this.userCareers);
        this.noCareer = this.userCandidate.id == null ? false : this.data.userCareers.length === 0;
        if (this.userCandidate.noindexCompanies) {
          if (this.userCandidate.noindexCompanies.length > 0) {
            this.data.company1 = this.userCandidate.noindexCompanies[0]
          }
          if (this.userCandidate.noindexCompanies.length > 1) {
            this.data.company2 = this.userCandidate.noindexCompanies[1]
          }
          if (this.userCandidate.noindexCompanies.length > 2) {
            this.data.company3 = this.userCandidate.noindexCompanies[2]
          }
        }
        this.completedMessage = null;
        this.errorMessage = null;
      },
      onInputNoCareer (value) {
        this.noCareer = value;
      },
      onInputCurrentJob(value) {
        this.data.userCandidate.currentJob = value
      },
      onUpdateUser (user) {
        this.data.user = user;
      },
      onUpdateUserCandidate (userCandidate) {
        this.data.userCandidate = userCandidate;
      },
      submit (e, guard) {
        guard((release) => {
          if (this.$refs.form.validate()) {
            this.saveUser(this.user.id, this.data.user).then(() => {
              const companies = [];
              if (this.data.company1) {
                companies.push(this.data.company1)
              }
              if (this.data.company2) {
                companies.push(this.data.company2)
              }
              if (this.data.company3) {
                companies.push(this.data.company3)
              }
              this.saveUserCandidate(
                  this.user.candidate,
                  {
                    ...this.data.userCandidate,
                    noindexCompanies: companies},
                  this.withDeleteFlag(this.userLanguages, this.data.userLanguages),
                  this.withDeleteFlag(this.userCareers, this.data.userCareers)
              ).then(() => {
                if (this.data.user.iconFile) {
                  this.saveUserCandidateIcon(this.user.id, this.data.user.iconFile).then(() => {
                    if (this.isSignUp) {
                      this.go("/thanks")
                    } else {
                      this.gtmDataLayer({
                        event: "edit_jobs",
                        service: "connect",
                        is_receive_mail: this.data.userCandidate.isReceiveMail
                      })
                    }
                    release()
                    this.close();
                  }).catch(() => {
                    release()
                    this.errorMessage = this.label("failedChangeProfile");
                  })
                } else {
                  if (this.isSignUp) {
                    this.go("/thanks")
                  } else {
                    this.gtmDataLayer({
                      event: "edit_jobs",
                      service: "connect",
                      is_receive_mail: this.data.userCandidate.isReceiveMail
                    })
                  }
                  release()
                  this.close();
                }
              }).catch( () => {
                release()
                this.errorMessage = this.label("failedChangeProfile");
              })
            }).catch( () => {
              release()
              this.errorMessage = this.label("failedChangeProfile");
            });
          } else {
            const dialogs = document.getElementsByClassName('profileEditDialog');
            let el = null;
            if (this.data.user.realName === null || this.data.user.realName === '') {
              el = document.getElementById('realName');
            } else if (!this.nameKanaValidate) {
              el = document.getElementById('realNameKana');
            } else if (this.data.user.birthDate == null || this.data.user.birthDate.length < 5) {
              el = document.getElementById('birthDate');
            } else if (this.data.user.gender === null) {
              el = document.getElementById('gender')
            } else if (this.data.user.zipCode == null || !this.data.user.zipCode.match(/^\d{3}-?\d{4}$/g)) {
              el = document.getElementById('zipCode');
            } else if (this.data.user.area === null) {
              el = document.getElementById('area');
            } else if (this.data.user.prefecture === null) {
              el = document.getElementById('prefecture');
            } else if (this.data.user.address === null) {
              el = document.getElementById('address');
            } else if (this.data.userCandidate.salary == null || this.data.userCandidate.salary.length < 1) {
              el = document.getElementById('salary');
            } else if (this.data.userCandidate.preferredLocations == null || this.data.userCandidate.preferredLocations.length === 0) {
              el = document.getElementById('preferredLocation');
            } else if (this.data.user.academicHistory === null) {
              el = document.getElementById('academicHistory');
            } else if (this.data.user.schoolName === null || this.data.user.schoolName.length < 1) {
              el = document.getElementById('schoolName');
            } else if (this.data.user.department === null || this.data.user.department.length < 1) {
              el = document.getElementById('department');
            } else if (this.data.user.graduated === null) {
              el = document.getElementById('graduated');
            } else if (this.data.user.graduatedYear === null) {
              el = document.getElementById('graduatedYear');
            } else if (!this.noCareer && this.data.userCareers.length === 0) {
              el = document.getElementById('career');
            }
            if (el) {
              Array.from(dialogs).forEach(dialog => {
                dialog.scrollTop = el.offsetTop;
              })
            }
            release()
          }
        }, false)
      },
      onClose () {
        this.init();
        this.close();
        this.$emit("cancel");
      },
      withDeleteFlag(currentItems, newItems) {
        const updateIds = newItems.filter(item => item.id != null).map(item => item.id);
        const deleteItems = currentItems.filter(item => !updateIds.includes(item.id)).map(item => ({...item, isDelete: true}));
        return newItems.map(item => ({...item, isDelete: false})).concat(deleteItems);
      }
    },
    computed: {
      ...mapGetters("user", ["user", "userCandidate", "userLanguages", "userCareers"]),
      saveButtonOffset () {
        if (this.hideCancel) {
          return 3;
        }
        return 0;
      },
      isSignUp () {
        return this.withTerm;
      },
      nameKanaValidate () {
        if (this.data.user.realNameKana === null || this.data.user.realNameKana === '') {
          return false
        }
        return this.data.user.realNameKana.match(/^[ァ-ヶー\s]*$/)
      },
    },
    components: {
      TextField,
      TermForm,
      PageTitle,
      ErrorMessage,
      ProfileDetailForm,
      EducationForm,
      CareerHistory,
      ProfileAdditionalForm,
      ActionButton,
      MessageBox,
      SectionTitle,
      FormItem,
      TextArea
    },
    watch: {
      open: {
        handler: function(value) {
          if (value) {
            this.init();
          }
        }
      },
      "user.id": {
        handler: function(value) {
          if (value.id) {
            this.init();
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
.notes
  font-size: 14px

</style>
